var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCollectionsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 88,
    r: 87,
    fill: "url(#paint0_linear_2111_20151)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0316 71.34H46.5405C45.9882 71.34 45.5405 71.7877 45.5405 72.34V77.4797C45.5405 78.032 45.9882 78.4797 46.5405 78.4797H67.0316C67.5839 78.4797 68.0316 78.032 68.0316 77.4797V72.34C68.0316 71.7877 67.5839 71.34 67.0316 71.34Z",
    fill: "#D4D9DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3008 60.9275H52.5359V72.6141H61.3008V60.9275Z",
    fill: "#D4D9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4029 174.276C89.7515 174.276 89.1828 174.019 89.0929 173.666L63.4449 73.4975C63.3452 73.1114 63.8532 72.7567 64.5799 72.7049C65.3017 72.6517 65.9725 72.9218 66.0721 73.3079L91.7202 173.477C91.8198 173.863 91.3118 174.217 90.5852 174.269C90.5244 174.273 90.4636 174.276 90.4053 174.276H90.4029Z",
    fill: "#D4D9DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8768 173.368C23.1508 172.462 22.3945 173.372 22.3327 173.368C21.5955 173.316 22.4822 172.5 21.9822 172.5H21.4822L21.69 170.785L47.1014 73.3076C47.2028 72.9215 47.8807 72.6528 48.6204 72.7046C49.3576 72.7564 49.8746 73.1125 49.7757 73.4972L23.6661 173.666C23.5746 174.02 23.4318 173.368 22.7688 173.368H22.8768Z",
    fill: "#D4D9DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6098 174.276C55.9121 174.276 55.3464 173.961 55.3464 173.572V73.4021C55.3464 73.0133 55.9121 72.6982 56.6098 72.6982C57.3076 72.6982 57.8732 73.0133 57.8732 73.4021V173.572C57.8732 173.961 57.3076 174.276 56.6098 174.276Z",
    fill: "#D4D9DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9399 120C56.6998 120 56.4616 119.925 56.2661 119.777L40.3644 107.709C39.9152 107.369 39.8532 106.761 40.2249 106.349C40.5967 105.939 41.2627 105.881 41.7119 106.222L56.9612 117.796L72.2801 106.925C72.739 106.598 73.4031 106.675 73.7613 107.098C74.1175 107.519 74.0343 108.127 73.5735 108.452L57.5846 119.798C57.3949 119.933 57.1664 120 56.9379 120H56.9399Z",
    fill: "#D4D9DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.029 31.6283L160.112 29.7037C161.145 29.3126 161.665 28.1581 161.274 27.125L153.99 7.87061C153.599 6.8375 152.445 6.31706 151.412 6.70817L146.329 8.63275C145.296 9.02386 144.775 10.1784 145.166 11.2115L152.45 30.4659C152.841 31.499 153.996 32.0194 155.029 31.6283Z",
    fill: "#D4D9DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 45.5194L152.662 31.0282L144.95 10.6444L106.676 25.1356L114.387 45.5194Z",
    fill: "#BDC3C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4945 58.1718L114.216 44.8625L106.976 25.7202L68.9861 40.9648L75.4945 58.1718Z",
    fill: "#BDC3C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0406 68.5399L36.7452 67.8949C36.9428 67.8201 37.0424 67.5992 36.9677 67.4016L33.9672 59.4662C33.8924 59.2685 33.6716 59.1689 33.474 59.2437L31.7694 59.8887C31.5717 59.9635 31.4721 60.1844 31.5469 60.3821L34.5474 68.3174C34.6221 68.5151 34.843 68.6147 35.0406 68.5399Z",
    fill: "#F1F4F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4232 70.2422L34.9081 69.68C35.1664 69.5822 35.2965 69.2936 35.1988 69.0353L31.5782 59.4651C31.4805 59.2068 31.1919 59.0767 30.9337 59.1745L29.4488 59.7367C29.1905 59.8345 29.0604 60.1231 29.1581 60.3814L32.7787 69.9516C32.8764 70.2098 33.1649 70.34 33.4232 70.2422Z",
    fill: "#BDC3C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3935 69.2227C36.5841 69.7268 37.1399 69.9892 37.6502 69.8159L74.5334 57.2972C75.0691 57.1154 75.3475 56.5257 75.1474 55.9966L70.2183 42.9621C70.019 42.4352 69.424 42.1768 68.903 42.3908L32.8814 57.1871C32.3807 57.3928 32.1346 57.9595 32.326 58.4658L36.3935 69.2227Z",
    fill: "#BDC3C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2569 40.8556L68.7189 41.0593C68.5213 41.1341 68.4217 41.355 68.4965 41.5527L74.7355 58.044C74.8103 58.2416 75.0311 58.3412 75.2287 58.2664L75.7667 58.0627C75.9644 57.9878 76.064 57.767 75.9892 57.5693L69.7502 41.078C69.6754 40.8804 69.4546 40.7808 69.2569 40.8556Z",
    fill: "#F1F4F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.069 24.9337L106.529 25.1336C106.331 25.207 106.23 25.4272 106.304 25.6254L113.631 45.4094C113.704 45.6076 113.924 45.7087 114.123 45.6353L114.662 45.4353C114.86 45.3619 114.961 45.1417 114.888 44.9436L107.561 25.1595C107.487 24.9613 107.267 24.8602 107.069 24.9337Z",
    fill: "#F1F4F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9529 169.131L90.5226 168.47L91.7562 173.27C91.8662 173.698 91.6085 174.134 91.1806 174.244L90.1605 174.507C89.7326 174.617 89.2965 174.359 89.1865 173.931L87.9529 169.131Z",
    fill: "#8E9EAE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3826 168L24.9465 168.634L23.756 173.445C23.6499 173.874 23.2162 174.136 22.7873 174.029L21.7765 173.779C21.3477 173.673 21.086 173.239 21.1921 172.811L22.3826 168Z",
    fill: "#8E9EAE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3467 169.218L57.8284 169.207L57.8496 174.188C57.8515 174.63 57.4948 174.99 57.053 174.992L56.1713 174.995C55.7295 174.997 55.3698 174.64 55.3679 174.199L55.3467 169.218Z",
    fill: "#8E9EAE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 16.6877L25 13.2465L16.3123 9.88433L12.7758 0L9.3278 9.63679L0 13.2465L9.53249 16.9352L12.7758 26L16.1076 16.6877Z",
    fill: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 16.6877L25 13.2465L16.3123 9.88433L12.7758 0L9.3278 9.63679L0 13.2465L9.53249 16.9352L12.7758 26L16.1076 16.6877Z",
    fill: "#BDC3C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2111_20151",
    x1: 68,
    y1: -295,
    x2: 87,
    y2: 244.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollectionsFound);
export default __webpack_public_path__ + "static/media/no-collections-found.0c274b2917790d5d07ef8033a158b905.svg";
export { ForwardRef as ReactComponent };